import {GET_MUST_CHANGE_PASSWORD} from 'shared/constants/ActionTypes';

const initialState = {
  form: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MUST_CHANGE_PASSWORD:
      return {
        ...state,
        form: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;